import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=787da0cc&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"
import style0 from "./footer-primary.vue?vue&type=style&index=0&id=787da0cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787da0cc",
  null
  
)

export default component.exports